import React from 'react';

const PublicArticleLoading: React.FC = () => {
    return (
        <div className="animate-pulse flex flex-col gap-6 pt-8">
            <div className="flex gap-2">
                <div className="h-6 w-16 rounded-full bg-input-background/10"/>
                <div className="h-6 w-20 rounded-full bg-input-background/10"/>
                <div className="h-6 w-12 rounded-full bg-input-background/10"/>
            </div>

            <div className="h-8 w-3/4 rounded bg-input-background/10"/>
            <div className="h-4 w-2/3 rounded bg-input-background/10"/>

            <div className="space-y-3">
                <div className="h-4 w-full rounded bg-input-background/10"/>
                <div className="h-4 w-11/12 rounded bg-input-background/10"/>
                <div className="h-4 w-10/12 rounded bg-input-background/10"/>
            </div>

            <div className="h-64 w-full rounded-xl bg-input-background/10"/>
        </div>
    );
};

export default PublicArticleLoading;


